"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionsLayout = void 0;
var _Button = require("../../elements/button/Button");
var _react = _interopRequireDefault(require("react"));
var _actionsLayoutModule = _interopRequireDefault(require("./actions-layout.module.scss"));
var ActionsLayout = function ActionsLayout(_ref) {
  var actionButtons = _ref.actionButtons;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _actionsLayoutModule.default['actions-layout']
  }, actionButtons.map(function (_ref2) {
    var name = _ref2.name,
      onClick = _ref2.onClick;
    return /*#__PURE__*/_react.default.createElement(_Button.StandardButton, {
      key: name,
      className: _actionsLayoutModule.default['actions-layout__action'],
      onClick: onClick
    }, name);
  }));
};
exports.ActionsLayout = ActionsLayout;